import React from "react";
import { Box, Skeleton } from "@mui/material";
import { Token } from "../../theme";

const cardStyle: React.CSSProperties = {
  background: Token.surfaceCard,
  border: `1px solid ${Token.borderDefault}`,
  borderRadius: 8,
};

/** Placeholder with the footprint of a KpiTile. */
export const KpiTileSkeleton: React.FC = () => (
  <Box data-testid="kpi-skeleton" style={{ ...cardStyle, padding: "14px 12px", display: "flex", flexDirection: "column" }}>
    <Box style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
      <Skeleton variant="text" width="45%" height={14} />
      <Skeleton variant="circular" width={20} height={20} />
    </Box>
    <Skeleton variant="text" width="55%" height={36} style={{ marginTop: 2 }} />
    <Skeleton variant="rounded" width="100%" height={6} style={{ marginTop: 10 }} />
  </Box>
);

/** Placeholder with the footprint of a dashboard OpsPanel list tile. */
export const PanelTileSkeleton: React.FC = () => (
  <Box data-testid="panel-skeleton" style={{ ...cardStyle, overflow: "hidden", width: "100%" }}>
    <Box
      style={{
        height: 46,
        padding: "0 12px",
        borderBottom: `1px solid ${Token.borderSubtle}`,
        display: "flex",
        alignItems: "center",
        gap: 8,
      }}
    >
      <Skeleton variant="rounded" width={16} height={16} />
      <Skeleton variant="text" width="35%" height={18} />
    </Box>
    <Box style={{ minHeight: "15.5em", padding: "8px 12px", display: "flex", flexDirection: "column", gap: 10 }}>
      {Array.from({ length: 4 }).map((_, index) => (
        <Box key={`panel-skeleton-row-${index}`}>
          <Skeleton variant="text" width={index % 2 === 0 ? "70%" : "60%"} height={16} />
          <Skeleton variant="text" width="35%" height={14} />
        </Box>
      ))}
    </Box>
  </Box>
);
